/**
 * @fileoverview Renders the additional contact cards for ContactsData.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { getCountryCodeOptions } from "../../../data/selectOptions";
import styles from "./ContactsData.module.css";

const AdditionalContactsList = ({
  AdditionalContact,
  additionalContacts,
  onRemove,
  onAdd,
  onContactChange,
  titleOptions,
  genderOptions,
  areaOptions,
  getFieldValidationState,
  getErrorMessage,
}) => {
  const { t } = useTranslation();
  const countryCodeOptions = getCountryCodeOptions(t);

  return (
    <div className={styles.additionalContactsContainer}>
      {additionalContacts.map((contact, index) => (
        <AdditionalContact
          key={contact.id}
          contact={contact}
          index={index}
          onRemove={onRemove}
          isLast={index === additionalContacts.length - 1}
          onAdd={onAdd}
          canAdd={additionalContacts.length < 9}
          onContactChange={onContactChange}
          titleOptions={titleOptions}
          countryCodeOptions={countryCodeOptions}
          genderOptions={genderOptions}
          areaOptions={areaOptions}
          getFieldValidationState={getFieldValidationState}
          getErrorMessage={getErrorMessage}
        />
      ))}
    </div>
  );
};

export default AdditionalContactsList;
